import { FC, Fragment, useState } from "react";
import {
  Avatar,
  CardHeader,
  Collapse,
  TableCell,
  TableRow,
} from "@mui/material";
import { PdfData } from "@/models/pdfData";
import { useResponsiveContext } from "@context/ResponsiveContext";
import { millisToDateTime } from "@/services/dateTimeService";
import GameListButtons from "./GameListButtons";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const GameListItem: FC<{ game: PdfData }> = ({ game }) => {
  const { onTablet } = useResponsiveContext();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Fragment key={game.samsId}>
      <TableRow onClick={handleClick}>
        <TableCell sx={{ ...(onTablet ? { border: 0 } : undefined) }}>
          {millisToDateTime(
            game.gameData.gameStartDateTime,
            onTablet ? "short" : "long",
          )}
        </TableCell>
        <TableCell sx={{ ...(onTablet ? { border: 0 } : undefined) }}>
          {game.gameData.team1.iconUrl && !onTablet ? (
            <CardHeader
              avatar={<Avatar src={game.gameData.team1.iconUrl} />}
              title={game.gameData.team1.longName}
            />
          ) : (
            game.gameData.team1.shortName
          )}
        </TableCell>
        <TableCell sx={{ ...(onTablet ? { border: 0 } : undefined) }}>
          {" "}
          {game.gameData.team2.iconUrl && !onTablet ? (
            <CardHeader
              avatar={<Avatar src={game.gameData.team2.iconUrl} />}
              title={game.gameData.team2.longName}
            />
          ) : (
            game.gameData.team2.shortName
          )}
        </TableCell>
        <TableCell sx={{ ...(onTablet ? { border: 0 } : undefined) }}>
          {!onTablet ? (
            <GameListButtons game={game} />
          ) : open ? (
            <ExpandLess />
          ) : (
            <ExpandMore />
          )}
        </TableCell>
      </TableRow>
      {onTablet && (
        <TableRow>
          <TableCell colSpan={5} sx={{ padding: 0 }}>
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
              sx={{ paddingY: 1 }}
            >
              <GameListButtons game={game} />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  );
};

export default GameListItem;
